'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var screenSize = 0;

var getScreenSize = function getScreenSize() {
  return screenSize = $(window).width();
};

var disableHover = function disableHover(item) {
  if ($(item).hasClass('no-hover') || $(item).closest('.collection-product-container').hasClass('hide-product-hover')) return true;
  return false;
};

var mouseEnter = exports.mouseEnter = function mouseEnter(item) {
  if (disableHover(item)) return;

  $(item).find('.img-main').each(function (index) {
    var hasHoverImg = $(this).attr('src-hover') || false;

    if (hasHoverImg && getScreenSize() > 600) {
      var hoverImgSrc = $(this).attr('src-hover');

      $(this).attr('src', hoverImgSrc);
    }
  });
};

var mouseLeave = exports.mouseLeave = function mouseLeave(item) {
  if (disableHover(item)) return;

  $(item).find('.img-main').each(function (index) {
    var mainImgSrc = $(this).attr('src-main');

    $(this).attr('src', mainImgSrc);
  });
};